import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef} from '@angular/material';
import {DialogConfigBase} from '../dialog-config-base';
import {DialogConfigInterface} from '../dialog-config.interface';

@Component({
  selector: 'app-image-preview-dialog',
  templateUrl: './image-preview-dialog.component.html',
  styleUrls: []
})
export class ImagePreviewDialogComponent implements OnInit {

  imageData: string;

  static getConfigBuilder(): any {
    return new ImagePreviewDialogConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              private dialog: MatDialogRef<ImagePreviewDialogComponent>) { }

  ngOnInit() {
    if (this.data && this.data.data) {
      this.imageData = this.data.data.imageData;
    }
  }

  close() {
    this.dialog.close();
  }

}

export class ImagePreviewDialogConfig extends DialogConfigBase implements DialogConfigInterface {

  private config: MatDialogConfig = {
    // panelClass: 'driver-sos-details-dialog-panel'
  };

  constructor() {
    super();
  }

  buildConfiguration(data: any): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
